<template>
  <div class="award_section">
    <div class="video_awards_section">
      <v-alert v-if="pending_payment"
               :value="true"
               type="warning"
               class="notranslate"
      >
        {{str.pending_payment}}
        <a v-if="get_last_payment && get_last_payment.details['payment_method'] === 'boleto' && validateTime(get_last_payment.details['boleto_expiration_date'])"
           :href="get_last_payment.details['boleto_url']"
           target="_blank"
        >{{str.view_bank_slip}}</a>
        <a v-else-if="get_last_payment && get_last_payment.details['payment_method'] === 'boleto' && !validateTime(get_last_payment.details['boleto_expiration_date'])"
           href="#"
           @click.prevent="payAwards(total_to_pay)"
        >{{str.expired_boleto}}</a>
        <a v-else
           href="#"
           @click.prevent="payAwards(total_to_pay)"
        >{{str.try_payment_again}}</a>
      </v-alert>
      <template v-else-if="allVideosCompleted && !pending_payment">
        <v-alert
          v-if="total_entries < free_entries"
          :value="true"
          type="success"
          class="notranslate"
        >
          {{ !already_submitted ? $t('you_can_send_up_to') : $t('confirmed_can_send_more') }}
          {{ $t('free_and_extra_entries_available', [
          free_entries - total_entries,
          parseInt(award['max_entries'], 10) - free_entries,
          extra_entry_price_formatted
          ]) }}
        </v-alert>
        <v-alert
          v-else-if="total_entries >= free_entries && total_entries < parseInt(award['max_entries'], 10)"
          :value="true"
          type="info"
          class="notranslate"
        >
          <template v-if="!already_submitted">
            {{ $t('extra_entries_available_and_price', [
            parseInt(award['max_entries'], 10) - total_entries,
            extra_entry_price_formatted
            ]) }}
          </template>
          <template v-else>
            {{ $t('confirmed_can_send_more_extra', [
            parseInt(award['max_entries'], 10) - total_entries,
            extra_entry_price_formatted
            ]) }}
          </template>
        </v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && !already_submitted"
          :value="true"
          type="warning"
          class="notranslate"
        >{{ $t('maximum_reached') }}</v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && (already_submitted['submission'].length < parseInt(award['max_entries'], 10))"
          :value="true"
          type="warning"
          class="notranslate"
        >{{ $t('maximum_reached') }}</v-alert>
        <v-alert
          v-else-if="(total_entries === parseInt(award['max_entries'], 10)) && (already_submitted['submission'].length >= parseInt(award['max_entries'], 10))"
          :value="true"
          type="success"
          class="notranslate"
        >{{ $t('maximum_reached_submitted') }}</v-alert>
      </template>
      <v-alert
        v-else
        :value="true"
        type="warning"
        class="notranslate"
      >
        {{str.videos_should_contain}}
      </v-alert>
      <AwardsSingleVideoLink
        v-for="(video, index) in videos"
        :key="index"
        :position="index"
        :videos="videos"
        pending_payment_message="oi"
        @submit-video="submitVideo"
        @remove-video="removeVideo"
      ></AwardsSingleVideoLink>

      <v-btn class="add_more"
             color="accent"
             v-if="canAddMore"
             @click="addVideo"
             large
      >
        {{(free_entries - total_entries >= 1)
          ? str.add_free_video
          : str.add_extra_video
        }}
        <v-icon class="notranslate" right dark>add_circle</v-icon>
      </v-btn>
      <AwardsBottomPay
        v-show="entries_to_submit >= 1 && allVideosCompleted"
        :total_to_pay="total_to_pay"
        @submit="confirm_dialog = true"
      />
    </div>
    <AwardsSideInfo :award="award"
                    :readyToSubmit="allVideosCompleted"
                    :total_to_pay="total_to_pay"
                    :entries_to_submit="entries_to_submit"
                    :free_entries_available="free_entries_available"
                    :extra_entries="extra_entries"
                    :submission="videos"
                    :profile="profile"
                    @submit="confirm_dialog = true"
    />
    <v-dialog v-model="confirm_dialog" persistent max-width="492">
      <v-card>
        <v-card-title class="headline">{{ str.confirm_submission }}?</v-card-title>
        <v-card-text>{{ str.rules_agreement }}</v-card-text>
        <v-card-text>
          {{ str.admit_judges_comments }}
          <v-radio-group v-model="admit_comments" column>
            <v-radio :label="str.admit_judges_comments_allow" value="allow"></v-radio>
            <v-radio :label="str.admit_judges_comments_refuse" value="refuse"></v-radio>
          </v-radio-group>
          <v-card-text class="admit_comments_allow_alert"
                       v-if="admit_comments === 'allow'"
          >{{ str.admit_judges_comments_accept_note }}</v-card-text>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed
                 color="accent"
                 @click="submitAwards"
                 :disabled="!admit_comments"
          >{{ total_to_pay > 0 ? str.pay_and_submit : str.submit }}</v-btn>
          <v-btn flat
                 color="info"
                 :href="award[`rules_page_${lang}_url`]"
                 target="_blank"
          >{{ str.read_the_rules }}</v-btn>
          <v-btn flat @click="confirm_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="success_dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">{{ str.success_dialog_title }}</v-card-title>
        <v-card-text>{{ str.success_dialog_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="success_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="error_dialog" persistent max-width="420">
      <v-card>
        <v-card-title class="headline">{{ str.error_dialog_title }}</v-card-title>
        <v-card-text>{{ str.error_dialog_text }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="accent" @click="submitAwards">{{str.try_again}}</v-btn>
          <v-btn flat @click="error_dialog = false">{{str.close}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="payment.dialog" max-width="470">
      <v-card>
        <v-card-title class="headline">
          <v-icon color="success"
                  class="notranslate"
                  left
                  v-if="payment.status === 'paid'"
          >check_circle</v-icon>
          <v-icon color="info"
                  class="notranslate"
                  left
                  v-else-if="payment.status === 'waiting_payment'"
          >info</v-icon>
          <v-icon color="error"
                  class="notranslate"
                  left
                  v-else
          >warning</v-icon>
          {{payment.title}}
        </v-card-title>
        <v-card-text>{{payment.text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat
                 v-if="payment.status === 'waiting_payment'"
                 color="accent"
                 :href="payment.url"
                 target="_blank"
          >{{str.view_bank_slip}}</v-btn>
          <v-btn flat
                 v-else-if="payment.status === 'refused'"
                 color="accent"
                 @click="submitAwards"
          >{{str.try_again}}</v-btn>
          <v-btn flat @click="payment.dialog = false">
            {{str.close}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="submitting" v-show="submitting.active">
      <h2>{{str.submiting}}</h2>
      <p v-if="submitting.current>0">
        {{str.processing_image}}
        {{submitting.current}}
        {{str.processing_image_of}}
        {{submitting.max}}
      </p>
      <p v-else>{{str.processing_submission}}</p>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AwardsSideInfo from './AwardsSideInfo'
import AwardsBottomPay from './AwardsBottomPay'
import VAlert from 'vuetify/es5/components/VAlert/VAlert'
import VBtn from 'vuetify/es5/components/VBtn/VBtn'
import VRadio from 'vuetify/es5/components/VRadioGroup/VRadio'
import VRadioGroup from 'vuetify/es5/components/VRadioGroup/VRadioGroup'
import strings from '../strings/AwardsVideoLink'
import paymentMixin from '../utils/payment_mixin'
import * as moment from 'moment'
import { submitAwards, registerAwards } from '../utils/api'
import { UPDATE_USER, UPDATE_SEGMENTS } from '../store/types'
import AwardsSingleVideoLink from './AwardsSingleVideoLink'
export default {
  name: 'AwardsVideoLink',
  components: { AwardsSingleVideoLink, VBtn, VAlert, AwardsSideInfo, AwardsBottomPay, VRadio, VRadioGroup },
  mixins: [
    paymentMixin
  ],
  props: {
    award: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      error: false,
      videos: [],
      confirm_dialog: false,
      success_dialog: false,
      error_dialog: false,
      admit_comments: '',
      submitting: {
        active: false,
        current: 0,
        max: 0
      },
      payment: {
        dialog: false,
        title: '',
        text: '',
        status: ''
      }
    }
  },
  computed: {
    lang: function () {
      return this.$store.state.user.language ? this.$store.state.user.language : 'en'
    },
    str: function () {
      return Object.keys(strings).reduce((acc, key) => {
        return {
          ...acc,
          [key]: strings[key][this.lang]
        }
      }, {})
    },
    allVideosCompleted: function () {
      return this.videos.filter(video =>
        video.url !== '' && video.title !== '' && video.cover !== '' && video.poster !== '' && video.category !== ''
      ).length === this.videos.length
    },
    canAddMore: function () {
      if (this.already_submitted) {
        if (
          this.already_submitted['payment_status'] === 'paid' ||
          this.already_submitted['payment_status'] === 'completed' ||
          this.already_submitted['payment_status'] === 'free'
        ) {
          return (
            (this.videos.length < this.award['max_entries']) &&
            this.allVideosCompleted
          )
        } else {
          return false
        }
      } else {
        return (
          (this.videos.length < this.award['max_entries']) &&
          this.allVideosCompleted
        )
      }
    },
    profile: function () {
      return this.$store.state.segments
        .find(el => el.slug === this.award['participant_segment'])
    },
    total_entries: function () {
      return this.videos.length
    },
    available: function () {
      return (this.award['max_entries'] - this.videos.length)
    },
    already_submitted: function () {
      const awardsSubmissions = this.profile['data']['awards_submissions']
      const thisAwardsIndex = Object.keys(awardsSubmissions).find(el => el == this.award['id'])
      if (thisAwardsIndex) {
        return awardsSubmissions[thisAwardsIndex]
      } else {
        return false
      }
    },
    already_confirmed: function () {
      if (this.already_submitted) {
        if (this.already_submitted['submission'].length <= this.free_entries) {
          return this.already_submitted['submission'].length
        } else {
          const alreadyPaidFor = Math.round(this.already_submitted['amount_paid'] / this.extra_entry_price)
          return alreadyPaidFor + this.free_entries
        }
      } else {
        return 0
      }
    },
    entries_to_submit: function () {
      if (this.already_submitted) {
        return Math.max(0, (this.total_entries - this.already_submitted['submission'].length))
      } else {
        return this.total_entries
      }
    },
    free_entries: function () {
      return this.profile.data.is_pro
          ? parseInt(this.award['free_entries'], 10)
          : 0
    },
    free_entries_available: function () {
      const defaultFreeEntries = this.free_entries
      if (this.already_submitted) {
        return Math.max(0, (defaultFreeEntries - this.already_submitted['submission'].length))
      } else {
        return defaultFreeEntries
      }
    },
    extra_entries: function () {
      return Math.max(0, (this.entries_to_submit - this.free_entries_available))
    },
    extra_entry_price: function () {
      const entry_field = this.$store.state.user['address']['country'].toLowerCase() === 'br'
        ? 'entry_price_brl'
        : 'entry_price_usd'
      const value = parseInt(this.award[entry_field], 10)
      return this.profile.data.is_pro ? value : value * 2
    },
    extra_entry_price_formatted: function () {
      const amount = (this.extra_entry_price / 100).toFixed(2)
      return (this.$store.state.user['address']['country'].toLowerCase() === 'br')
          ? amount.replace('.', ',')
          : amount
    },
    total_to_pay: function () {
      if (this.already_submitted) {
        const entriesPending = (this.total_entries - this.already_confirmed)
        return entriesPending * this.extra_entry_price
      } else {
        return this.extra_entries * this.extra_entry_price
      }
    },
    pending_payment: function () {
      if (this.already_submitted) {
        return !(
          this.already_submitted['payment_status'] === 'paid' ||
          this.already_submitted['payment_status'] === 'completed' ||
          this.already_submitted['payment_status'] === 'free'
        )
      } else {
        return false
      }
    },
    pending_payment_message: function () {
      if (this.pending_payment) {
        if (
          this.get_last_payment &&
          this.get_last_payment.details['payment_method'] === 'boleto' &&
          this.validateTime(this.get_last_payment.details['boleto_expiration_date'])
        ) {
          return {
            message: this.str.view_bank_slip,
            url: this.get_last_payment.details['boleto_url']
          }
        } else if (
          this.get_last_payment &&
          this.get_last_payment && this.get_last_payment.details['payment_method'] === 'boleto' &&
          !this.validateTime(this.get_last_payment.details['boleto_expiration_date'])
        ) {
          return {
            message: this.str.expired_boleto,
            url: null
          }
        } else {
          return {
            message: this.str.try_again,
            url: null
          }
        }
      } else {
        return null
      }
    },
    get_last_payment: function () {
      if (this.already_submitted) {
        return this.$store.state.user['payment_history']
          .find(el => el.id === this.already_submitted['payment_id'])
      } else {
        return null
      }
    }
  },
  methods: {
    validateTime: function (time) {
      return moment().isBefore(time * 1000)
    },
    submitVideo: function (index, videoInfo) {
      this.videos = [
        ...this.videos.slice(0, index),
        videoInfo,
        ...this.videos.slice(index + 1)
      ]
    },
    addVideo: function () {
      this.videos = [
        ...this.videos,
        {
          url: '',
          title: '',
          cover: '',
          poster: '',
          category: '',
          submitted: false,
          confirmed: false
        }
      ]
    },
    removeVideo: function (index) {
      this.videos = this.videos.filter((el, i) => i !== index)
    },
    submitAwards: async function () {
      this.payment.dialog = false
      this.confirm_dialog = false
      this.error_dialog = false
      this.submitting.active = true
      this.submitting.current = 0
      this.submitting.max = 0
      const totalToPay = this.total_to_pay
      console.log('total to pay', totalToPay)

      const videoToSubmit = this.videos.slice(this.already_submitted
        ? this.already_submitted['submission'].length
        : 0
      )

      let submitResult = []
      let errorCatched = false

      await submitAwards(this.profile['data']['id'], this.award['id'], videoToSubmit)
        .then(result => {
          if (!(result instanceof TypeError) && result['awards_submission']) {
            submitResult = result['awards_submission']
          } else {
            errorCatched = true
          }
        })
        .catch(err => {
          console.log(err)
          errorCatched = true
        })

      registerAwards(
        this.profile['data']['id'],
        this.award['id'],
        submitResult,
        this.admit_comments
      ).then(finalResult => {
        if (finalResult['result'] === 'success') {
          this.$store.commit(UPDATE_USER, finalResult['new_user'])
          this.$store.commit(UPDATE_SEGMENTS, finalResult['new_segments'])
          this.submitting.active = false
          this.updateVideosSubmitted()
          if (totalToPay > 0) {
            this.payAwards(totalToPay)
          } else {
            this.success_dialog = true
          }
        }
      })
    },
    payAwards: function (totalToPay = 0) {
      console.log('payAwards invoked')
      const realTotalToPay = (totalToPay === 0) ? this.total_to_pay : totalToPay
      this.makePayment(
        realTotalToPay,
        {
          finality: 'awards',
          extra_entries: this.extra_entries.toString(),
          awards_title: this.award['title'],
          awards_id: this.award['id'],
          post_id: this.profile['data']['id'],
          user_id: this.$store.state.user.id
        },
        'boleto, credit_card'
      ).then(paymentResult => {
        console.log(paymentResult)
        this.updateVideosSubmitted()
        this.payment.dialog = true
        this.payment.title = paymentResult.title
        this.payment.text = paymentResult.text
        this.payment.status = paymentResult.status
        this.payment.url = paymentResult.url
      })
    },
    updateVideosSubmitted: function () {
      if (this.already_submitted) {
        this.videos = [
          ...Object.values(this.already_submitted['submission']).map((el, i) => {
            return {
              ...el,
              submitted: true,
              confirmed: ((i + 1) <= this.already_confirmed)
            }
          })
        ]
      }
    }
  },
  mounted () {
    this.updateVideosSubmitted()
  }
}
</script>

<style scoped lang="scss">
  @keyframes sk-bouncedelay {
    0%, 80%, 100% {
      transform: scale(0);
    } 40% {
        transform: scale(1.0);
      }
  }
  .add_more {
    display: block;
    margin: 48px auto;
  }
  .v-alert {
    position: sticky;
    top: 84px;
    z-index: 39;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    font-size: 16px;
    a {
      color: #fff;
    }
  }
  .submitting {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.75);
    z-index: 999999;
    padding: 96px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-content: center;
    pointer-events: none;
    h2 {
      color: #fff;
      font-size: 36px;
    }
    p {
      color: #fff;
      margin: 0;
      font-size: 24px;
    }
    .spinner {
      margin: 48px auto 0;
      width: 84px;
      text-align: center;
      div {
        width: 24px;
        height: 24px;
        margin: 0 2px;
        background-color: rgba(255,255,255,0.7);
        border-radius: 100%;
        display: inline-block;
        animation: sk-bouncedelay 1.4s infinite ease-in-out both;
        &.bounce1 {
          animation-delay: -0.32s;
        }
        &.bounce2 {
          animation-delay: -0.16s;
        }
      }
    }
  }
</style>

<i18n>
  {
    "en": {
      "you_can_send_up_to": "You can send up to",
      "confirmed_can_send_more": "Your participation in this contest has already been confirmed, but you can still submit up to",
      "free_and_extra_entries_available": "{0} more entries for free and {1} more extra entries for U$ {2} each",
      "extra_entries_available_and_price": "You can send up to {0} more entries for U$ {1} each",
      "confirmed_can_send_more_extra": "Your participation in this contest has already been confirmed, but you can still submit up to {0} more entries for U$ {1} each",
      "maximum_reached": "You have reached the maximum number of entries allowed",
      "maximum_reached_submitted": "Your participation in this contest has already been performed and your submission contains the maximum number of entries allowed"
    },
    "pt": {
      "you_can_send_up_to": "Você pode enviar até mais",
      "confirmed_can_send_more": "Sua participação neste concurso já está confirmada, mas você ainda pode enviar até mais",
      "free_and_extra_entries_available": "{0} entrada(s) gratuitamente e mais {1} entrada(s) extras por R$ {2} cada",
      "extra_entries_available_and_price": "Você pode enviar até mais {0} entradas extras por R$ {1} cada",
      "confirmed_can_send_more_extra": "Sua participação neste concurso está confirmada, mas você pode enviar até mais {0} entradas extras por R$ {1} cada",
      "maximum_reached": "Você chegou ao máximo de entradas permitidas",
      "maximum_reached_submitted": "Sua participação neste concurso já foi realizada e seu envio contém o máximo de entradas permitidas"
    }
  }
</i18n>
